/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Metadata_HeaderInputs */

const en_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADATA****`)
};

const fr_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADONNEES****`)
};

const de_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADATEN****`)
};

const it_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADATI****`)
};

const ru_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****МЕТАДАННЫЕ****`)
};

const es_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADATOS****`)
};

const zh_cn2_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****元数据****`)
};

const ja_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****メタデータ****`)
};

const hi_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****मेटाडेटा****`)
};

const pt_pt2_transcript_export_metadata_header = /** @type {(inputs: Transcript_Export_Metadata_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`****METADADOS****`)
};

/**
* | output |
* | --- |
* | "****METADATA****" |
*
* @param {Transcript_Export_Metadata_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_metadata_header = /** @type {((inputs?: Transcript_Export_Metadata_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Metadata_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_metadata_header(inputs)
	if (locale === "de") return de_transcript_export_metadata_header(inputs)
	if (locale === "it") return it_transcript_export_metadata_header(inputs)
	if (locale === "ru") return ru_transcript_export_metadata_header(inputs)
	if (locale === "es") return es_transcript_export_metadata_header(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_metadata_header(inputs)
	if (locale === "ja") return ja_transcript_export_metadata_header(inputs)
	if (locale === "hi") return hi_transcript_export_metadata_header(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_metadata_header(inputs)
	return en_transcript_export_metadata_header(inputs)
});